import { d as r } from "../internals/descriptors.js";
import { r as t } from "../internals/regexp-unsupported-dot-all.js";
import { c as e } from "../internals/classof-raw.js";
import { d as i } from "../internals/define-built-in-accessor.js";
import { i as s } from "../internals/internal-state.js";
var o = s.get,
  n = RegExp.prototype,
  a = TypeError;
r && t && i(n, "dotAll", {
  configurable: !0,
  get: function get() {
    if (this !== n) {
      if ("RegExp" === e(this)) return !!o(this).dotAll;
      throw a("Incompatible receiver, RegExp required");
    }
  }
});